
export function calcFinalPrice(product, options) {
  let finalPrice = product.price;
  // const isDiscount = checkProductDiscount(product);
  // if (!!isDiscount) {
  //   finalPrice = product.price_discount;
  // }

  return finalPrice;
}

export function getDummyImage(filename) {
  return `https://zalo-miniapp.github.io/zaui-coffee/dummy/${filename}`;
}

export function isIdentical(
  option1,
  option2
) {
  const option1Keys = Object.keys(option1);
  const option2Keys = Object.keys(option2);

  if (option1Keys.length !== option2Keys.length) {
    return false;
  }

  for (const key of option1Keys) {
    const option1Value = option1[key];
    const option2Value = option2[key];

    const areEqual =
      Array.isArray(option1Value) &&
      Array.isArray(option2Value) &&
      [...option1Value].sort().toString() ===
        [...option2Value].sort().toString();

    if (option1Value !== option2Value && !areEqual) {
      return false;
    }
  }

  return true;
}

export function checkProductDiscount(product) {
  if (!!product?.discount_ended_at) {
    const endedDiscount = new Date(
      replaceAllCustom(product.discount_ended_at, "-", "/")
    );
    const startedDiscount = new Date(
      replaceAllCustom(product.discount_started_at, "-", "/")
    );
    const date = new Date();
    const isDiscount =
      startedDiscount.getTime() < date.getTime() &&
      endedDiscount.getTime() > date.getTime();
    return isDiscount;
  }
  return false;
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
export function replaceAllCustom(str, find, replace) {
  return str?.replace(new RegExp(escapeRegExp(find), "g"), replace) || "";
}
